import produce from 'immer';
import { 
  SET_DETAIL_TABLE ,
  LOADER_STATUS,
  SET_B2B_SUMMARY,
  SET_B2BA_SUMMARY,
  SET_CDNUR_SUMMARY,
  SET_EXPA_SUMMARY,
  SET_DOC_ISSUE_SUMMARY,
  SET_TXPD_SUMMARY,
  SET_TXPDA_SUMMARY,
  SET_HSN_SUMMARY,
  SET_EXP_SUMMARY,
  SET_CDNURA_SUMMARY,
  SET_NIL_SUMMARY,
  SET_CDNRA_SUMMARY,
  SET_CDNR_SUMMARY,
  SET_B2CL_SUMMARY,
  SET_B2CLA_SUMMARY,
  SET_B2CSA_SUMMARY,
  SET_B2CS_SUMMARY,
  SET_AT_SUMMARY,
  SET_DOWNLOAD_BUTTON,
  SET_ATA_SUMMARY,
  SET_OTP_BOX,
  OTP_INVALID,
  SUMMARY_TO_FILE
} from './constants';





export const initialState = {
    loaderStatus: false,
    detailTable:false,
    isOtpActive:false,
    isOtpInvalid: false,
    b2bSummary:[],
    b2baSummary:[],
    cdnurSummary:[],
    expaSummary:[],
    docIssueSummary:[],
    txpdSummary:[],
    txpdaSummary:[],
    hsnSummary:[],
    expSummary:[],
    cdnuraSummary:[],
    nilSummary:[],
    cdnrSummary:[],
    cdnraSummary:[],
    b2clSummary:[],
    b2claSummary:[],
    b2csaSummary:[],
    b2csSummary:[],
    atSummary:[],
    ataSummary:[],
    summaryToFile:[],
    isDownloadButton:false
  };


  const summaryReducer = (state = initialState, action) =>{
    switch (action.type) {

      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        };
      case SET_DETAIL_TABLE:
        return {
          ...state,
          detailTable:action.detailTable
        };
      case SET_OTP_BOX:
        return {
          ...state,
          isOtpActive:action.isOtpActive
        };
      case OTP_INVALID:
        return {
          ...state,
          isOtpInvalid:action.status
        };
      case SET_B2B_SUMMARY:
        return {
          ...state,
          b2bSummary:action.summary
        };
      case SET_B2BA_SUMMARY:
        return {
          ...state,
          b2baSummary:action.summary
        };
      case SET_CDNUR_SUMMARY:
        return {
          ...state,
          cdnurSummary:action.summary
        };
      case SET_EXPA_SUMMARY:
        return {
          ...state,
          expaSummary:action.summary
        };
      case SET_DOC_ISSUE_SUMMARY:
        return {
          ...state,
          docIssueSummary:action.summary
        };
      case SET_TXPD_SUMMARY:
        return {
          ...state,
          txpdSummary:action.summary
        };
      case SET_TXPDA_SUMMARY:
        return {
          ...state,
          txpdaSummary:action.summary
        }
      case SET_HSN_SUMMARY:
        return {
          ...state,
          hsnSummary:action.summary
        }
      case SET_EXP_SUMMARY:
        return {
          ...state,
          expSummary:action.summary
        }
      case SET_CDNURA_SUMMARY:
        return {
          ...state,
          cdnuraSummary:action.summary
        }
      case SET_NIL_SUMMARY:
        return {
          ...state,
          nilSummary:action.summary
        }
      case SET_CDNRA_SUMMARY:
        return {
          ...state,
          cdnraSummary:action.summary
        }
      case SET_CDNR_SUMMARY:
        return {
          ...state,
          cdnrSummary:action.summary
        }
      case SET_B2CL_SUMMARY:
        return {
          ...state,
          b2clSummary:action.summary
        }
      case SET_B2CLA_SUMMARY:
        return {
          ...state,
          b2claSummary:action.summary
        }
      case SET_B2CSA_SUMMARY:
        return {
          ...state,
          b2csaSummary:action.summary
        }
      case SET_B2CS_SUMMARY:
        return {
          ...state,
          b2csSummary:action.summary
        }
      case SET_AT_SUMMARY:
        return {
          ...state,
          atSummary:action.summary
        }
      case SET_ATA_SUMMARY:
        return {
          ...state,
          ataSummary:action.summary
        }
      case SET_DOWNLOAD_BUTTON:
        return {
          ...state,
          isDownloadButton:action.status
        }
      case SUMMARY_TO_FILE:
        return {
          ...state,
          summaryToFile:action.summaryToFile
        }
      default:
        return state; 
    }
  };

  export default summaryReducer;